

























































import { Vue, Component, Prop } from "vue-property-decorator";

export enum CockpitEntryInfoType {
  EventInfo,
  Counter,
  Appointment,
  Header,
  Text,
}

export interface ProjectCounterInfo {
  name: string;
  count: number | undefined | string;
}

export interface CockpitEntryInfo {
  id: number | string;
  infoType: CockpitEntryInfoType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  shouldBeDisplayed: boolean;
  shouldBeHighlighted?: boolean;
  sortValue?: number;
  onClickCallback?: () => void;
}

@Component({})
export default class CockpitEntryInfoItemComponent extends Vue {
  @Prop() cockpitEntryInfo!: CockpitEntryInfo;
  @Prop() elevation!: number;
  @Prop() maxCounterWidth!: string;
  @Prop() addMarginTop!: boolean;
  @Prop({ default: "" }) backgroundStyle!: string;

  get showHeader() {
    return (
      this.cockpitEntryInfo &&
      this.cockpitEntryInfo.infoType === CockpitEntryInfoType.Header
    );
  }

  get showProjectCounterInfo() {
    return (
      this.cockpitEntryInfo &&
      this.cockpitEntryInfo.infoType === CockpitEntryInfoType.Counter
    );
  }

  get showTextInfo() {
    return (
      this.cockpitEntryInfo &&
      this.cockpitEntryInfo.infoType === CockpitEntryInfoType.Text
    );
  }

  get showAppointmentInfo() {
    return (
      this.cockpitEntryInfo &&
      this.cockpitEntryInfo.infoType === CockpitEntryInfoType.Appointment
    );
  }

  get showEventInfo() {
    return (
      this.cockpitEntryInfo &&
      this.cockpitEntryInfo.infoType === CockpitEntryInfoType.EventInfo
    );
  }

  onOpen() {
    this.cockpitEntryInfo.onClickCallback &&
      this.cockpitEntryInfo.onClickCallback();
  }
}
